export function render () {
  console.info('footer')
}